import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './contexts/AuthContext';
import { Flowbite } from 'flowbite-react';
import customTheme from './theme';
import { LocationProvider } from './contexts/LocationContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <LocationProvider>
        <Flowbite theme={{ theme: customTheme }}>
          <App />
        </Flowbite>
      </LocationProvider>
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      // Register or update service worker
      const registration = await navigator.serviceWorker.register('/service-worker.js', {
        scope: '/',
        updateViaCache: 'none'
      });
      console.log('SW registered:', registration);

      // Handle direct navigation after page load if flag is set
      if (window.__DIRECT_NAVIGATION__) {
        delete window.__DIRECT_NAVIGATION__;
        // Force React Router to update based on current URL
        // Store the event in a global variable to avoid naming conflicts
        window.__lastPopStateEvent = new PopStateEvent('popstate');
        window.dispatchEvent(window.__lastPopStateEvent);
      }
    } catch (error) {
      console.log('SW registration failed:', error);
    }
  });
}
